"use client";
import { jsx as s, jsxs as h } from "react/jsx-runtime";
import { forwardRef as p, useState as y, useRef as C, useImperativeHandle as w, useEffect as d } from "react";
import { createPortal as L } from "react-dom";
p((u, m) => {
  const {
    modalRoot: b = document.body,
    initialState: f = !1,
    preventClose: t = !1,
    preventCloseOutside: v = !1,
    styles: c = "",
    children: E,
    onAfterClose: i
    // <<< NEW
  } = u, [a, o] = y(f), l = C(null);
  w(m, () => ({
    handlerModalAction: (e) => r(e)
  }));
  const r = (e) => {
    switch (e) {
      case "OPEN":
        o(!0);
        break;
      case "CLOSE":
        o(!1), i && i();
        break;
      default:
        o(!1);
    }
  }, k = (e) => {
    var n;
    e.target instanceof HTMLElement && (n = e.target.parentElement) != null && n.classList.contains("block-overlay") && !t && !v && r("CLOSE");
  };
  if (d(() => {
    const e = (n) => {
      n.key === "Escape" && !t && r("CLOSE");
    };
    return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
  }, [t]), d(() => {
    a && l.current && l.current.focus();
  }, [a]), a) {
    const e = `modal-${Math.random().toString(36).substring(2, 15)}`;
    return L(
      /* @__PURE__ */ s(
        "section",
        {
          ref: l,
          tabIndex: -1,
          role: "dialog",
          "aria-modal": "true",
          className: `block-overlay${c ? ` ${c}` : ""}${a ? " active" : ""}`,
          "aria-labelledby": e,
          "data-react-block": "true",
          children: /* @__PURE__ */ s("div", { className: "part", onClick: k, id: e, children: /* @__PURE__ */ h("div", { className: "content-holder", children: [
            E,
            !t && /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                "aria-label": "Fechar Janela",
                className: "close-overlay",
                onClick: () => r("CLOSE")
              }
            )
          ] }) })
        }
      ),
      b
    );
  }
  return null;
});
